import { c as _c } from "react/compiler-runtime";
import { getAnalytics } from '../lib/utils';
import type { ProductCardEntrypointProps } from '../model/types';
import { ProductCard } from './Content';
export const ProductCardEntrypoint = t0 => {
  const $ = _c(17);
  const {
    analytics,
    creditCardOffer,
    driverGroup,
    initiallyExpandedAccordion,
    showSkeleton,
    slug,
    shouldPrioritizeImage: t1,
    isLtoHighlightingEnabled: t2,
    trafficOriginType,
    hideOuterBorder
  } = t0;
  const shouldPrioritizeImage = t1 === undefined ? false : t1;
  const isLtoHighlightingEnabled = t2 === undefined ? false : t2;
  const isEligibleForReward = creditCardOffer.details.eligibleForNerdWalletPlusBonus;
  let t3;
  if ($[0] !== analytics || $[1] !== creditCardOffer || $[2] !== isEligibleForReward) {
    t3 = getAnalytics(analytics, creditCardOffer, "roundup_recommendations", {
      nw_plus_eligible: isEligibleForReward
    });
    $[0] = analytics;
    $[1] = creditCardOffer;
    $[2] = isEligibleForReward;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    ctaAnalytics,
    skuViewedProps,
    marketplacePayload
  } = t3;
  let t4;
  if ($[4] !== creditCardOffer || $[5] !== ctaAnalytics || $[6] !== driverGroup || $[7] !== hideOuterBorder || $[8] !== initiallyExpandedAccordion || $[9] !== isLtoHighlightingEnabled || $[10] !== marketplacePayload || $[11] !== shouldPrioritizeImage || $[12] !== showSkeleton || $[13] !== skuViewedProps || $[14] !== slug || $[15] !== trafficOriginType) {
    t4 = <div data-pc-layout="responsive"><ProductCard ctaAnalytics={ctaAnalytics} creditCardOffer={creditCardOffer} driverGroup={driverGroup} entityName="roundup_recommendations_card" marketplacePayload={marketplacePayload} initiallyExpandedAccordion={initiallyExpandedAccordion} showSkeleton={showSkeleton} skuViewedProps={skuViewedProps} slug={slug} shouldPrioritizeImage={shouldPrioritizeImage} isLtoHighlightingEnabled={isLtoHighlightingEnabled} trafficOriginType={trafficOriginType} hideOuterBorder={hideOuterBorder} /></div>;
    $[4] = creditCardOffer;
    $[5] = ctaAnalytics;
    $[6] = driverGroup;
    $[7] = hideOuterBorder;
    $[8] = initiallyExpandedAccordion;
    $[9] = isLtoHighlightingEnabled;
    $[10] = marketplacePayload;
    $[11] = shouldPrioritizeImage;
    $[12] = showSkeleton;
    $[13] = skuViewedProps;
    $[14] = slug;
    $[15] = trafficOriginType;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};